import "../../bindings/bao-searcher";
import "../../bindings/bao-toggle-buttons";
import "../../bindings/element";
import "../../bindings/bao-upload";
import * as ko from "knockout";
import * as $ from "jquery";
import Bao from "../../services/bao-service";
import BaoDialogViewModel from "../../factories/bao-dialog";
import ChildTabViewModel from "../../factories/child-tab-view-model";
import TabPage from "../../factories/tab-page";


///View Model for the Document Tab of the InstructionView
class InstructionDocumentTab extends ChildTabViewModel {

    instructionVM: KnockoutObservable<any>;

    constructor(instructionVM: any, tabPage: any) {
        super(tabPage, parent);
        this.TabPage = tabPage;

        this.instructionVM = ko.observable(instructionVM);

        this.instructionVM().SubTabsSaveFn.push(() => { return this.Save(); });

        this.DirtyFlag = this.instructionVM().TabPage.DirtyFlag;

        this.PageIndex(0);
        this.PageSize(10);
        this.TotalRows(0);

        this._msgCancel = Bao.Session.GetMessage("msgCancel");
        this._msgOk = Bao.Session.GetMessage("msgOk");
        this._Subscriptions = [];
        this.InitializeDialogs();

        this.OriginalTabTitle = this.TabPage.Title();
        this.TotalRows.subscribe((value) => {
            if (value == null || value == 0) {
                this.TabPage.Title(this.OriginalTabTitle);
                return;
            }
            this.TabPage.Title(this.OriginalTabTitle + " (" + value + ")");
        });

        this._Subscriptions.push(this.instructionVM().InstructionAttachment.subscribe(() => {
            this.UpdateReferenceDocumentCollection();
        }));

        this._Subscriptions.push(this.SelectedReferenceDocumentRow.subscribe(() => {
            this.ToggleToolbarButtons();
        }));

        this._Subscriptions.push(this.ToolbarButtons.subscribe(() => {
            this.ToggleToolbarButtons();
        }));

        this._Subscriptions.push(this.instructionVM().IsHistory.subscribe(() => {
            this.SelectedReferenceDocumentRow(null);
            this.ToggleToolbarButtons();
        }));
    }

    public TabPage;
    public Dialog: BaoDialogViewModel;
    public LinkDialog: BaoDialogViewModel = new BaoDialogViewModel(Bao.Session.ApplicationName);

    public Template: KnockoutObservable<string> = ko.observable();
    public TemplateContext: KnockoutObservable<string> = ko.observable();

    public DirtyFlag: KnockoutObservable<boolean> = ko.observable();
    public IsHistory: KnockoutObservable<boolean> = ko.observable();

    public PageIndex: KnockoutObservable<number> = ko.observable();
    public PageSize: KnockoutObservable<number> = ko.observable();
    public TotalRows: KnockoutObservable<number> = ko.observable();

    public RenderElement: KnockoutObservable<any> = ko.observable();
    public SelectedReferenceDocumentRow: KnockoutObservable<any> = ko.observable();

    public Sorting: KnockoutObservableArray<any> = ko.observableArray();
    public DocumentCollection: KnockoutObservableArray<any> = ko.observableArray();
    public ToolbarButtons: KnockoutObservableArray<any> = ko.observableArray();

    private _msgCancel: KnockoutObservable<string> = ko.observable();
    private _msgOk: KnockoutObservable<string> = ko.observable();

    private OriginalTabTitle: KnockoutObservable<string> = ko.observable();

    private _Subscriptions: KnockoutSubscription[];

    public init() {
        this.UpdateReferenceDocumentCollection();
        this.ToggleToolbarButtons();
    }

    public Refresh() {
        var def = $.Deferred();
        Bao.post("Instruction/ResetSession", JSON.stringify({
            sessionTabId: this.instructionVM().SessionTabId()
        }), () => {
            this.RefreshGrid().then(() => {
                def.resolve();
            });
        });
        return def.promise();
    }

    public StringIsNullOrEmpty(string) {
        if (string === null)
            return true;
        else if (string === "")
            return true;
        else if (typeof string === "undefined")
            return true;
        return false;
    }

    public CompleteCheck() {
        return true;
    }

    // takes the attachment list from the Info Viewmodel and fetches it in a local list and calculates the row count
    public UpdateReferenceDocumentCollection() {
        let InstructionAttachmentBuffer: Array<any> = new Array();

        this.instructionVM().InstructionAttachment().forEach(attachment => {
            if (attachment.DeleteInRevision() === null || attachment.DeleteInRevision() > this.instructionVM().Revision()) {
                InstructionAttachmentBuffer.push(attachment);
            }
        })

        this.DocumentCollection([]);
        this.DocumentCollection(InstructionAttachmentBuffer);
        this.TotalRows(this.DocumentCollection().length);
    }

    public InitializeDialogs() {
        this.Dialog = new BaoDialogViewModel(Bao.Session.ApplicationName);
        this.Dialog.Width("450px");
        this.Dialog.Buttons([
            new BaoDialogViewModel.ButtonFactory(this.Dialog, this._msgOk, () => {
                if (!Bao.Utils.String.IsNullOrEmpty(this.Dialog.ViewModel().Description())) {
                    this.Dialog.IsLoading(true);
                    this.Dialog.ViewModel().Upload().then(() => {
                        this.Dialog.IsLoading(false);
                        this.Dialog.Close();
                        this.Refresh();
                    })
                }
                else {
                    new BaoDialogViewModel(Bao.Session.ApplicationName, Bao.Session.GetMessage("msgFillMandatorFields"), "info");
                }
            }),
            new BaoDialogViewModel.ButtonFactory(this.Dialog, this._msgCancel, () => { this.Dialog.Close(); })
        ]);

        this.LinkDialog = new BaoDialogViewModel(Bao.Session.ApplicationName);
        this.LinkDialog.Width("450px");
        this.LinkDialog.Buttons([
            new BaoDialogViewModel.ButtonFactory(this.LinkDialog, this._msgOk, () => {
                if (!Bao.Utils.String.IsNullOrEmpty(this.LinkDialog.ViewModel().Description())) {
                    this.LinkDialog.IsLoading(true);
                    let item = this.LinkDialog.ViewModel();
                    let model = ko.map.toJS(item);
                    this.AddInstructionDocument(model, this.instructionVM().InstructionId()).then(() => {
                        this.LinkDialog.IsLoading(false);
                        this.LinkDialog.Close();
                    });
                } else {
                    new BaoDialogViewModel(Bao.Session.ApplicationName, Bao.Session.GetMessage("msgFillMandatorFields"), "info");
                }
            }),
            new BaoDialogViewModel.ButtonFactory(this.LinkDialog, this._msgCancel, () => { this.LinkDialog.Close(); })
        ]);
    }

    // opens the dialog for attaching documents
    public ShowInstructionDocumentDialog(instructionId, InstructionAttachmentId) {
        return Bao.post("Instruction/ShowInstructionDocumentDialog", JSON.stringify({
            sessionTabId: this.instructionVM().SessionTabId(),
            instructionId: instructionId,
            instructionAttachmentId: InstructionAttachmentId
        }), (value) => {
            var vm = ko.map.fromJS(value.Model);
            vm.Upload = function () { };
            vm.SelectedFiles = ko.observableArray<string>();
            vm.IsEdit = InstructionAttachmentId != null;
            vm.DocumentType = 0;
            if (InstructionAttachmentId != null) {
                vm.UploadUrl = 'Instruction/UploadAttachment?sessionTabId=' + this.instructionVM().SessionTabId() + '&InstructionId=' + instructionId + '&InstructionAttachmentId=' + InstructionAttachmentId;
            }
            else {
                vm.UploadUrl = 'Instruction/UploadAttachment?sessionTabId=' + this.instructionVM().SessionTabId() + '&InstructionId=' + instructionId;
            }
            this.Dialog.ViewModel(vm);
            this.Dialog.Template(value.Message);
            this.Dialog.Open();
        });
    }

    // opens the dialog for attaching links
    public ShowInstructionLinkDialog(instructionId, InstructionAttachmentId) {
        return Bao.post("Instruction/ShowInstructionDocumentDialog", JSON.stringify({
            sessionTabId: this.instructionVM().SessionTabId(),
            instructionId: instructionId,
            InstructionAttachmentId: InstructionAttachmentId
        }), (value) => {
            var vm = ko.map.fromJS(value.Model);
            vm.IsEdit = InstructionAttachmentId != null;
            vm.DocumentType = 1;
            this.LinkDialog.ViewModel(vm);
            this.LinkDialog.Template(value.Message);
            this.LinkDialog.Open();
        });
    }

    // updates the attachment list of the instruction viewmodel
    public RefreshGrid() {
        this.TabPage.IsLoading(true);
        return Bao.post("Instruction/SearchInstructionAttachmentCollection", JSON.stringify({
            sessionTabId: this.instructionVM().SessionTabId(),
            instructionId: this.instructionVM().InstructionId(),
            pageIndex: this.PageIndex(),
            pageSize: this.PageSize(),
            sorting: this.Sorting()
        }), (searchResult) => {
            this.TabPage.IsLoading(false);
            this.SelectedReferenceDocumentRow(null);
            this.TotalRows(0);
            this.instructionVM().InstructionAttachment([]);
            if (searchResult != null && searchResult.Models != null) {
                ko.map.fromJS(searchResult.Models, this.instructionVM().InstructionAttachment);
            }
        });
    }

    public AddInstructionDocument(model, instructionId) {
        this.TabPage.IsLoading(true);
        return Bao.post("Instruction/AddInstructionAttachment", JSON.stringify({
            sessionTabId: this.instructionVM().SessionTabId(),
            referenceDocumentModel: ko.map.toJS(model),
            instructionId: instructionId
        }), () => {
            this.instructionVM().TabPage.DirtyFlag(true);
            return this.Refresh();
        });
    }

    public DeleteInstructionAttachment(InstructionAttachmentId) {
        var questionDialog = new BaoDialogViewModel(Bao.Session.ApplicationName, Bao.Session.GetMessage("msgDeleteConfigurationItemReferenceDocument"), "yesno");
        this._Subscriptions.push(questionDialog.DialogResult.subscribe((result) => {
            if (result === true) {
                return Bao.post("Instruction/RemoveAttachment", JSON.stringify({
                    sessionTabId: this.instructionVM().SessionTabId(),
                    attachmentId: InstructionAttachmentId,
                    deleteInRevision: this.instructionVM().Revision()
                }), () => {
                    this.instructionVM().TabPage.DirtyFlag(true);
                    this.RefreshGrid();
                });
            }
        }));
    }

    public OpenAttachment = (instructionAttachmentId) => {
        if (this.SelectedReferenceDocumentRow().DocumentType() == 1)
        {
            this.OpenLink(this.SelectedReferenceDocumentRow().Link());
        }
        else {
            window.open(window.absolutePath + 'Instruction/DownloadAttachment/' + instructionAttachmentId);
        }
    };

    public OpenLink = (link) => {
        if (link.startsWith('http')) {
            window.open(link);
        }
        else {
            window.open('https://' + link);
        }
    }

    public ToolbarClick = (action) => {
        switch (action.ActionKey()) {
            case "AddInstructionDocument":
                this.ShowInstructionDocumentDialog(this.instructionVM().InstructionId(), null);
                break;
            case "AddInstructionDocumentLink":
                this.ShowInstructionLinkDialog(this.instructionVM().InstructionId(), null);
                break;
            case "EditInstructionDocument":
                if (this.SelectedReferenceDocumentRow() != null) {
                    if (this.SelectedReferenceDocumentRow().DocumentType() == 1) {
                        this.ShowInstructionLinkDialog(this.instructionVM().InstructionId(), this.SelectedReferenceDocumentRow().InstructionAttachmentId());
                    }
                    else {
                        this.ShowInstructionDocumentDialog(this.instructionVM().InstructionId(), this.SelectedReferenceDocumentRow().InstructionAttachmentId());
                    }
                }
                break;
            case "DeleteInstructionDocument":
                if (this.SelectedReferenceDocumentRow() != null) {
                    this.DeleteInstructionAttachment(this.SelectedReferenceDocumentRow().InstructionAttachmentId());
                }
                break;
            case "DownloadInstructionDocument":
                if (this.SelectedReferenceDocumentRow() != null) {
                    this.OpenAttachment(this.SelectedReferenceDocumentRow().InstructionAttachmentId());
                }
                break;
        }
    };

    public ToggleToolbarButtons() {
        ko.utils.arrayForEach(this.ToolbarButtons(), (button) => {
            switch (button.ActionKey()) {
                case "AddInstructionDocument":
                    button.Enabled(!this.instructionVM().IsHistory())
                    break;
                case "AddInstructionDocumentLink":
                    button.Enabled(!this.instructionVM().IsHistory())
                    break;
                case "EditInstructionDocument":
                    button.Enabled(this.SelectedReferenceDocumentRow() !== null && this.SelectedReferenceDocumentRow() !== undefined && !this.instructionVM().IsHistory());
                    break;
                case "DeleteInstructionDocument":
                    button.Enabled(this.SelectedReferenceDocumentRow() !== null && this.SelectedReferenceDocumentRow() !== undefined && !this.instructionVM().IsHistory());
                    break;
                case "DownloadInstructionDocument":
                    button.Enabled(this.SelectedReferenceDocumentRow() !== null && this.SelectedReferenceDocumentRow() !== undefined);
                    break;
            }
        });
    }
}
export default InstructionDocumentTab;